<div class="support-chat-mobile-wrapper">
  <button mat-icon-button (click)="closeChatList()" class="chats-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <nz-tabs (nzSelectedIndexChange)="tabChanged($event)">
    <nz-tab [nzTitle]="foreignersTabTitle">
      <div class="chat-filters-wrapper foreigners">
        <div class="chat-filters">
          <div
            class="filter-item filter-input-text"
            style="display: flex; justify-content: space-between; align-items: center; width: 75%; margin: 20px">
            <nz-input-group [nzSuffix]="suffixIconSearchA" nzSize="small" class="query-input">
              <input
                type="text"
                nz-input
                [ngModel]="(pagination$ | async)?.supportedUserName || ''"
                (ngModelChange)="debouncedSearch({ supportedUserName: $event })"
                placeholder="{{ 'CHAT.SEARCH_BY_NAME' | translate }}"
                style="min-width: 200px" />
            </nz-input-group>
            <ng-template #suffixIconSearchA>
              @if (!(pagination$ | async)?.supportedUserName) {
                <span nz-icon nzType="search"> </span>
              }
              @if ((pagination$ | async)?.supportedUserName) {
                <span
                  nz-icon
                  class="ant-input-clear-icon"
                  nzTheme="fill"
                  nzType="close-circle"
                  (click)="searchSupportChats({ supportedUserName: null })"></span>
              }
            </ng-template>
          </div>

          <nz-switch
            [ngModel]="(pagination$ | async)?.onlyAssignedToMe"
            (ngModelChange)="searchSupportChats({ onlyAssignedToMe: $event })"
            [nzUnCheckedChildren]="AllIcon"
            [nzCheckedChildren]="OnlyMineIcon"
            nz-tooltip
            [nzTooltipTitle]="(pagination$ | async)?.onlyAssignedToMe ? OnlyMineTooltip : AllTooltip">
          </nz-switch>
          <ng-template #OnlyMineIcon>
            <span nz-icon nzType="user-switch"></span>
          </ng-template>
          <ng-template #AllIcon>
            <span nz-icon nzType="global"></span>
          </ng-template>
          <ng-template #OnlyMineTooltip>
            <span [innerHTML]="'CHAT.ONLY_ASSIGNED_TO_ME' | translate"></span>
          </ng-template>
          <ng-template #AllTooltip>
            <span [innerHTML]="'CHAT.ALL_ASSIGNED' | translate"></span>
          </ng-template>
        </div>
      </div>

      <div class="chat-list-wrapper">
        <nz-spin
          [nzIndicator]="indicatorTemplate"
          [nzDelay]="10"
          [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
          class="main-support-chats-list-loading-indicator">
          <div class="list" #chatsList>
            @for (supportChat of foreignersSupportChatsList$ | async; track supportChat) {
              <div
                class="item"
                (click)="openSupportChat(supportChat)"
                [class.open]="supportChat.id === (openSupportChat$ | async)?.supportChat?.id"
                [class.unread]="supportChat.hasUnreadMessages"
                [class.attention-required]="supportChat.marker === SupportChatMarker.ATTENTION_REQUIRED"
                [class.already-handled]="supportChat.marker === SupportChatMarker.ALREADY_HANDLED"
                [class.comeback-later]="supportChat.marker === SupportChatMarker.COMEBACK_LATER">
                <div class="column">
                  <div class="last-message">
                    @if (supportChat.lastMessageAt) {
                      <span class="avatar-like">
                        {{ supportChat.lastMessageAt | date: 'dd.MM' }}

                        <span
                          class="presence-dot"
                          [class.online]="supportChat.supportedUserOnline"
                          [class.offline]="!supportChat.supportedUserOnline">
                        </span>
                      </span>
                    } @else {
                      <span
                        class="presence-dot standalone"
                        [class.online]="supportChat.supportedUserOnline"
                        [class.offline]="!supportChat.supportedUserOnline">
                      </span>
                    }
                  </div>
                  <div class="name">
                    {{ supportChat.supportedUser?.name || 'MISSING USERNAME' }}
                  </div>
                </div>
                <div class="column">
                  @switch (supportChat.marker) {
                    @case (SupportChatMarker.ATTENTION_REQUIRED) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> priority_high </mat-icon>
                    }
                    @case (SupportChatMarker.COMEBACK_LATER) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> schedule </mat-icon>
                    }
                    @case (SupportChatMarker.ALREADY_HANDLED) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> check_circle </mat-icon>
                    }
                  }

                  <button
                    nz-button
                    *appRequiredSupportingCompany="{
                      requiredAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
                      companyId: supportChat.supportedUser.companyId,
                    }"
                    nzType="text"
                    nzShape="round"
                    nzSize="small"
                    class="application-list-trigger"
                    (click)="$event.stopPropagation()"
                    [routerLink]="['/management/foreigner-details', supportChat.supportedUserId]"
                    [queryParams]="{ tabIndex: 1 }">
                    <span class="material-symbols-outlined"> note_stack </span>
                  </button>
                  <button
                    nz-button
                    nz-dropdown
                    nzType="text"
                    nzShape="round"
                    nzSize="small"
                    nzTrigger="click"
                    (click)="$event.stopPropagation()"
                    [nzDropdownMenu]="itemMarkersMenu"
                    [nzPlacement]="'bottomLeft'"
                    [nzClickHide]="true"
                    class="markers-dropdown-trigger">
                    <mat-icon fontSet="material-icons-outlined">more_horiz</mat-icon>
                  </button>
                  <nz-dropdown-menu #itemMarkersMenu="nzDropdownMenu">
                    <ul nz-menu>
                      @for (item of availableMenuItems; track item) {
                        @if (!item.supportedTypes || item.supportedTypes.includes(ROLES_KEYS.Foreigner)) {
                          <li
                            nz-menu-item
                            class="menu-item"
                            [ngClass]="{ disabled: item.disabledFn && item.disabledFn(supportChat) }"
                            *appRequiredSupportingCompany="
                              item.requiredSupportingCompanyAccessLevel
                                ? {
                                    requiredAccessLevel: item.requiredSupportingCompanyAccessLevel,
                                    companyId: supportChat.supportedUser.companyId,
                                  }
                                : null
                            "
                            [routerLink]="item.routerLink ? item.routerLink.concat(supportChat.supportedUserId) : null"
                            [queryParams]="item.queryParams || null"
                            (click)="actionHandlers[item.actionKey](supportChat)">
                            <mat-icon
                              class="marker-icon"
                              [ngClass]="item.iconCustomClass || 'icon-grey'"
                              fontSet="material-icons-outlined">
                              {{ item.icon }}
                            </mat-icon>
                            <span>{{ item.labelKey | translate }}</span>
                          </li>
                        }
                      }
                    </ul>
                  </nz-dropdown-menu>
                </div>
              </div>
            }
            <div class="item last-item">
              @if (loadingMoreChats$ | async) {
                <div class="loading-wrapper" role="status" aria-live="polite">
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>

                  <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
                </div>
              }
              @if (allChatsLoaded) {
                <div class="no-more-items-message">
                  {{ 'CHAT.NO_MORE_SUPPORT_CHATS' | translate }}
                </div>
              }
            </div>
          </div>
        </nz-spin>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="employersTabTitle">
      <div class="chat-filters-wrapper">
        <div class="chat-filters">
          <div
            class="filter-item filter-input-text"
            style="display: flex; justify-content: space-between; align-items: center; width: 75%; margin: 20px">
            <nz-input-group [nzSuffix]="suffixIconSearchB" nzSize="small" class="query-input">
              <input
                type="text"
                nz-input
                [ngModel]="(pagination$ | async)?.supportedUserName || ''"
                (ngModelChange)="debouncedSearch({ supportedUserName: $event })"
                placeholder="{{ 'CHAT.SEARCH_BY_NAME' | translate }}"
                style="min-width: 200px" />
            </nz-input-group>
            <ng-template #suffixIconSearchB>
              @if (!(pagination$ | async)?.supportedUserName) {
                <span nz-icon nzType="search"> </span>
              }
              @if ((pagination$ | async)?.supportedUserName) {
                <span
                  nz-icon
                  class="ant-input-clear-icon"
                  nzTheme="fill"
                  nzType="close-circle"
                  (click)="searchSupportChats({ supportedUserName: null })"></span>
              }
            </ng-template>
          </div>
        </div>
      </div>

      <div class="chat-list-wrapper">
        <nz-spin
          [nzIndicator]="indicatorTemplate"
          [nzDelay]="10"
          [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
          class="main-support-chats-list-loading-indicator">
          <div class="list" #chatsList>
            @for (supportChat of employersSupportChatsList$ | async; track supportChat) {
              <div
                class="item"
                (click)="openSupportChat(supportChat)"
                [class.open]="supportChat.id === (openSupportChat$ | async)?.supportChat?.id"
                [class.unread]="supportChat.hasUnreadMessages"
                [class.attention-required]="supportChat.marker === SupportChatMarker.ATTENTION_REQUIRED"
                [class.already-handled]="supportChat.marker === SupportChatMarker.ALREADY_HANDLED"
                [class.comeback-later]="supportChat.marker === SupportChatMarker.COMEBACK_LATER">
                <div class="column">
                  <div class="last-message">
                    @if (supportChat.lastMessageAt) {
                      <span class="avatar-like">
                        {{ supportChat.lastMessageAt | date: 'dd.MM' }}

                        <span
                          class="presence-dot"
                          [class.online]="supportChat.supportedUserOnline"
                          [class.offline]="!supportChat.supportedUserOnline">
                        </span>
                      </span>
                    } @else {
                      <span
                        class="presence-dot standalone"
                        [class.online]="supportChat.supportedUserOnline"
                        [class.offline]="!supportChat.supportedUserOnline">
                      </span>
                    }
                  </div>
                  <div class="name">
                    {{ supportChat.supportedUser?.name || 'MISSING USERNAME' }}
                  </div>
                </div>
                <div class="column">
                  @switch (supportChat.marker) {
                    @case (SupportChatMarker.ATTENTION_REQUIRED) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> priority_high </mat-icon>
                    }
                    @case (SupportChatMarker.COMEBACK_LATER) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> schedule </mat-icon>
                    }
                    @case (SupportChatMarker.ALREADY_HANDLED) {
                      <mat-icon class="marker-icon" fontSet="material-icons-outlined"> check_circle </mat-icon>
                    }
                  }

                  <button
                    nz-button
                    nz-dropdown
                    nzType="text"
                    nzShape="round"
                    nzSize="small"
                    nzTrigger="click"
                    (click)="$event.stopPropagation()"
                    [nzDropdownMenu]="itemMarkersMenu"
                    [nzPlacement]="'bottomLeft'"
                    [nzClickHide]="true"
                    class="markers-dropdown-trigger">
                    <mat-icon fontSet="material-icons-outlined">more_horiz</mat-icon>
                  </button>
                  <nz-dropdown-menu #itemMarkersMenu="nzDropdownMenu">
                    <ul nz-menu>
                      @for (item of availableMenuItems; track item) {
                        @if (!item.supportedTypes || item.supportedTypes.includes(ROLES_KEYS.Employer)) {
                          <li
                            nz-menu-item
                            class="menu-item"
                            [ngClass]="{ disabled: item.disabledFn && item.disabledFn(supportChat) }"
                            *appRequiredSupportingCompany="
                              item.requiredSupportingCompanyAccessLevel
                                ? {
                                    requiredAccessLevel: item.requiredSupportingCompanyAccessLevel,
                                    companyId: supportChat.supportedUser.companyId,
                                  }
                                : null
                            "
                            [routerLink]="item.routerLink ? item.routerLink.concat(supportChat.supportedUserId) : null"
                            [queryParams]="item.queryParams || null"
                            (click)="actionHandlers[item.actionKey](supportChat)">
                            <mat-icon
                              class="marker-icon"
                              [ngClass]="item.iconCustomClass || 'icon-grey'"
                              fontSet="material-icons-outlined">
                              {{ item.icon }}
                            </mat-icon>
                            <span>{{ item.labelKey | translate }}</span>
                          </li>
                        }
                      }
                    </ul>
                  </nz-dropdown-menu>
                </div>
              </div>
            }
            <div class="item last-item">
              @if (loadingMoreChats$ | async) {
                <div class="loading-wrapper" role="status" aria-live="polite">
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>

                  <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
                </div>
              }
              @if (allChatsLoaded) {
                <div class="no-more-items-message">
                  {{ 'CHAT.NO_MORE_SUPPORT_CHATS' | translate }}
                </div>
              }
            </div>
          </div>
        </nz-spin>
      </div>
    </nz-tab>
  </nz-tabs>

  <ng-template #foreignersTabTitle>
    <span>
      {{ 'COMMON.LABEL.FOREIGNERS' | translate }}
      <nz-badge [nzCount]="myUnreadCountForeigners$ | async" [nzOverflowCount]="99" class="tab-badge"> </nz-badge>
    </span>
  </ng-template>

  <ng-template #employersTabTitle>
    <span>
      {{ 'COMMON.LABEL.EMPLOYERS' | translate }}
      <nz-badge [nzCount]="myUnreadCountEmployers$ | async" [nzOverflowCount]="99" class="tab-badge"> </nz-badge>
    </span>
  </ng-template>
</div>

<ng-template #indicatorTemplate><span nz-icon nzType="loading"></span></ng-template>
